import { Image, Crops } from '@cook-types/cook'

import { Vtype } from '@components/AppNexus/types'
import { PlayerType } from './types/darkcove'
import { Theme } from '@themes/default'
import { createCropParams } from '@utils/schema'

//TODO: not all methods are using, revise them

interface GetVideoTypeParamProps {
  duration: number
  shortVideoLengthThresholdInSeconds: number
}

export const isLiveStream = (duration: number): boolean =>
  duration === -1 || duration === Infinity

export const getVideoTypeParam = ({
  duration,
  shortVideoLengthThresholdInSeconds,
}: GetVideoTypeParamProps): Vtype => {
  if (isLiveStream(duration)) {
    return Vtype.LIVESTREAM
  }

  switch (duration) {
    case undefined:
      return Vtype.DEFAULT
    default:
      if (Number.isInteger(duration)) {
        return duration >= shortVideoLengthThresholdInSeconds
          ? Vtype.LONGFORM
          : Vtype.SHORTFORM
      }
      return Vtype.DEFAULT
  }
}

export const getAdSkipTime = (
  vtype: Vtype,
  defaultTImeInSeconds: number
): number => (vtype === Vtype.SHORTFORM ? defaultTImeInSeconds : 0)

export const getContextVideoType = ({
  isBlickTV,
  allowFloating,
}: {
  isBlickTV: boolean
  allowFloating: boolean
}): 'blicktv' | 'integrated' =>
  isBlickTV && allowFloating ? 'blicktv' : 'integrated'

export const getPlayerType = ({
  isBlickTV,
  duration,
}: {
  isBlickTV: boolean
  duration: number
}): PlayerType =>
  isBlickTV
    ? PlayerType.LIVE
    : duration === -1
    ? PlayerType.LIVE_IN_ARTICLE
    : PlayerType.VOD

export const getPosterImageUrl = (
  baseUrl: string,
  image?: Omit<Image<Crops>, 'width' | 'height'>
): string | undefined =>
  (image?.src && !image?.crops && `${baseUrl}${image.src}?ratio=16_9`) ||
  (image?.src &&
    image?.crops &&
    `${baseUrl}${image.src}?ratio=16_9${createCropParams({
      crops: image.crops,
      ratio: {
        name: '16_9',
        width: 16,
        height: 9,
      },
    })}`) ||
  undefined

const ZATTOO_CHANNEL_PLACEHOLDER = '{channel}'
const YOUTUBE_SRC_ID = 'www.youtube.com/embed'
const YOUTUBE_NOCOOKIE_SRC_ID = 'www.youtube-nocookie.com/embed'

export const getDurationType = (duration: number) =>
  (duration === -1 && 'LIVE') || (duration > 0 && 'VOD') || 'INVALID'

export const isExtraColonAllowed = (text: string) =>
  [':', '!', '?', '.'].some((punctuation) => text.endsWith(punctuation))

export const getTextWithExtraColon = (text: string) =>
  `${text}${isExtraColonAllowed(text) ? '' : ':'}`

export const createZattooUrl = (templateUrl: string, channel: string) =>
  templateUrl.replace(ZATTOO_CHANNEL_PLACEHOLDER, channel)

export const isYoutubeUrl = (url: string) => {
  if (!url) {
    return false
  }

  return url.includes(YOUTUBE_SRC_ID) || url.includes(YOUTUBE_NOCOOKIE_SRC_ID)
}
export const getVideoIdFromYoutubeUrl = (url: string) => {
  if (!url) {
    return
  }

  const idWithSuffix = /^.+embed\/(.+)$/.exec(url)?.[1]
  const videoId = idWithSuffix?.endsWith('/')
    ? idWithSuffix.slice(0, -1)
    : idWithSuffix

  return videoId
}

export const toggleThemeColor = (theme: Theme) => {
  const {
    colors: {
      white,
      page: { inverted },
    },
  } = theme

  const themeColor =
    document
      ?.querySelector('meta[name="theme-color"]')
      ?.getAttribute('content') === white
      ? inverted
      : white

  document
    ?.querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', themeColor)
}
